export default [
    {
        path: "/admin/payroll-cycles",
        name: "payroll-cycle",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/payroll-cycle/index.vue")
    }
];

